import { Component, Output, EventEmitter  } from '@angular/core';
import { BaseComponent } from '@app/directives/base-component';

@Component({
    selector: 'c_side_modal_approval_process_component',
    templateUrl: './c_side_modal_approval_process.component.html',
    styleUrls: ['../../common.scss', '../../c_side_modal.component.scss'],
    standalone: false
})
export class c_side_modal_approval_process_component extends BaseComponent {

  constructor() { super(); }

}
